<ng-container>
  <form [formGroup]="form">
    <div class="form-row">
      <mat-form-field>
        <mat-label>Navn</mat-label>
        <input type="text" matInput formControlName="name" />
        @if (nameFormControl.hasError('required')) {
          <mat-error> Indtast venligst et navn på adgangsgruppen </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-row">
      <mat-form-field class="actions__status">
        <mat-label>Vælg biltype</mat-label>
        <mat-select formControlName="carType" okCustomDropDownArrowDirective>
          @for (cartype of carTypes | enumToArray | translateAccessGroupCarTypeEnum; track cartype) {
            <mat-option [value]="cartype.index">
              {{ cartype.name }}
            </mat-option>
          }
        </mat-select>
        <mat-icon matSuffix></mat-icon>
      </mat-form-field>
    </div>
    <div class="form-row">
      <mat-form-field class="actions__shared-discount">
        <mat-label>Tværgående rabat</mat-label>
        <mat-select formControlName="sharedDiscountIdentifier" okCustomDropDownArrowDirective>
          <mat-option [value]="null">Ingen</mat-option>
          @for (discount of sharedDiscounts; track discount) {
            <mat-option [value]="discount.identifier">
              {{ discount.name }} ({{ discount.amount }} {{ discount.discount_type | translateOrganizationDiscountType }})
            </mat-option>
          }
        </mat-select>
        <mat-icon matSuffix></mat-icon>
      </mat-form-field>
    </div>
    <div class="form-row discount">
      <mat-form-field class="discount__amount">
        <mat-label>Rabat</mat-label>
        <input type="text" [inputMask]="priceInputMask" matInput formControlName="amount" />
        @if (amountFormControl.hasError('min') || amountFormControl.hasError('max')) {
          <mat-error>
            <div>Rabatten skal være en værdi mellem 0 og 100</div>
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Rabat type</mat-label>
        <mat-select formControlName="discountType" okCustomDropDownArrowDirective>
          @for (type of discountTypes | keyvalue; track type) {
            <mat-option [value]="type.key">
              {{ type.key | translateOrganizationDiscountType }}
            </mat-option>
          }
        </mat-select>
        <mat-icon matSuffix></mat-icon>
        <mat-hint class="text-warning">Rabat type styring foregår på organisationen</mat-hint>
      </mat-form-field>
    </div>
  </form>

  <div class="form-row flex">
    <button class="margin--right-m margin--left-auto" type="button" mat-button (click)="handleCancel()">Annuller</button>
    <button
      type="button"
      mat-raised-button
      [color]="'secondary'"
      data-pw="create-access-group"
      [disabled]="!form || !form.valid"
      (click)="handleSave()">
      @if (accessGroup) {
        Gem
      } @else {
        Opret adgangsgruppe
      }
    </button>
  </div>
</ng-container>
